import React from 'react';
import { useAuth } from '../../context/AuthContext';
import DashboardShell from '../DashboardShell';
import useFetch from '../useFetch';

/** Admin sidebar. Every item here is backed by an admin-only API route. */
const AdminApp = () => {
  const { currentUser } = useAuth();
  const overview = useFetch('/admin/overview');
  const owed = overview.data?.attention?.owed_resellers || 0;
  const pending = overview.data?.attention?.pending_approvals || 0;

  const nav = [
    { group: 'Manage', to: '/admin', label: 'Overview', icon: 'overview', end: true },
    { group: 'Manage', to: '/admin/resellers', label: 'Resellers', icon: 'resellers', badge: pending || undefined },
    { group: 'Manage', to: '/admin/commissions', label: 'Commissions', icon: 'commissions' },
    { group: 'Manage', to: '/admin/payouts', label: 'Payouts', icon: 'payouts', badge: owed || undefined },
    { group: 'Manage', to: '/admin/customers', label: 'Customers', icon: 'customers' },
    { group: 'Manage', to: '/admin/activity', label: 'Activity', icon: 'activity' },
    { group: 'Platform', to: '/admin/products', label: 'finOS products', icon: 'products' },
  ];

  return (
    <DashboardShell
      nav={nav}
      roleLabel="Admin"
      roleNote="Full access to all resellers"
      userName={currentUser?.email || 'Admin'}
    />
  );
};

export default AdminApp;
